export const HYBRID_MAIL_ROOM = {
  HYBRID_MAIL_ROOM_TITLE: { key: 'HYBRID_MAIL_ROOM_TITLE', value: 'Hybrid Mail Room' },
  SEND_LETTERS_TITLE: { key: 'SEND_LETTERS_TITLE', value: 'Send letters' },
  HYBRID_MAIL_TITLE_DES: { key: 'HYBRID_MAIL_TITLE_DES', value: 'Upload your completed letters and configure split criteria' },
  UPLOAD_TEXT: { key: 'UPLOAD_TEXT', value: 'Upload a .docx or .pdf file to send out a new mail' },
  GET_STARTED_BUTTON: { key: 'GET_STARTED_BUTTON', value: 'Get Started' },
  SEND_LETTERS_TEXT: { key: 'SEND_LETTERS_TEXT', value: 'Send letters' },
  RECIPIENT_TYPE_LABEL: { key: 'RECIPIENT_TYPE_LABEL', value: 'Recipient Type' },
  HYBRID_JOB_NAME: { key: 'HYBRID_JOB_NAME', value: 'Job Name' },
  JOB_NAME_PLACEHOLDER: {
    key: 'JOB_NAME_PLACEHOLDER',
    value: 'Enter a descriptive name for your batch job',
  },
  SPLIT_CRITERIA_LABEL: { key: 'SPLIT_CRITERIA_LABEL', value: 'Split Criteria' },
  PAGE_COUNT_LABEL: { key: 'PAGE_COUNT_LABEL', value: 'Page Count' },
  RECIPIENT_TYPE_SINGLE: { key: 'RECIPIENT_TYPE_SINGLE', value: 'Single' },
  RECIPIENT_TYPE_MULTIPLE: { key: 'RECIPIENT_TYPE_MULTIPLE', value: 'Multiple' },
  SPLIT_CRITERIA_ADDRESS: { key: 'SPLIT_CRITERIA_ADDRESS', value: 'Address' },
  SPLIT_CRITERIA_PAGE: { key: 'SPLIT_CRITERIA_PAGE', value: 'Page Count' },
  DRAG_AND_DROP: { key: 'DRAG_AND_DROP', value: 'Drag and drop your completed letters here' },
  TO_SEND_LETTERS: { key: 'TO_SEND_LETTERS', value: 'To send completed letters, drag and drop your files into this area or select them by clicking here' },
  SUPPORTED_FORMATS: { key: 'SUPPORTED_FORMATS', value: 'Supported formats: PDF, DOCX' },
  PAGE_COUNT_PLACEHOLDER: { key: 'PAGE_COUNT_PLACEHOLDER', value: 'Enter page count' },
  CANCEL_BUTTON: { key: 'CANCEL_BUTTON', value: 'Cancel' },
  PROCEED_BUTTON: { key: 'PROCEED_BUTTON', value: 'Proceed' },
};

export const HYBRID_MAIL = {
  SIDE_BAR_TITLE: { key: 'SIDE_BAR_TITLE', value: 'Hybrid Mail' },
  CONFIGURE_LETTER_SETTINGS: { key: 'CONFIGURE_LETTER_SETTINGS', value: 'Configure Letter Settings' },
  PREVIEW: { key: 'PREVIEW', value: 'PREVIEW' },
  PROCESS_BATCH: { key: 'PROCESS_BATCH', value: 'PROCESS BATCH' },
  SEND_LETTER: { key: 'SEND_LETTER', value: 'SEND LETTER' },
  ENVELOPE_TYPE: { key: 'ENVELOPE_TYPE', value: 'Envelope Type' },
  DELIVERY_CLASS: { key: 'DELIVERY_CLASS', value: 'Delivery class' },
  STATIONARY: { key: 'STATIONARY', value: 'Stationary' },
  INSERT: { key: 'INSERT', value: 'Insert' },
  TOOLTIP_UPLOAD_INSERT: { key: 'TOOLTIP_UPLOAD_INSERT', value: 'Upload Insert' },
  SHIFT_CONTENT: { key: 'SHIFT_CONTENT', value: 'Shift content' },
  TOOLTIP_SHIFT_CONTENT: { key: 'TOOLTIP_SHIFT_CONTENT', value: 'If the content overlaps the envelope address box, increase this value to move the content downward.' },
  EXIT_PREVIEW: { key: 'EXIT_PREVIEW', value: 'Exit Preview' },
  PROCESS_SELECTED_TEXT: { key: 'PROCESS_SELECTED_TEXT', value: 'Process Selected Text' },
  TOOLTIP_PROCESS_SELECTED_TEXT: { key: 'TOOLTIP_PROCESS_SELECTED_TEXT', value: 'Use this option to apply the selected text as the envelope address.' },
  RETURN_TO_DASHBOARD: { key: 'RETURN_TO_DASHBOARD', value: 'Return to Dashboard' },
  LOADING_TEXT: { key: 'LOADING_TEXT', value: 'Loading...' },
  SEARCH_LETTER_PLACEHOLDER: { key: 'SEARCH_LETTER_PLACEHOLDER', value: 'Search letter by name or address' },
  DOCUMENTS_SPLIT_BY: { key: 'DOCUMENTS_SPLIT_BY', value: 'Documents split by {{criteria}}' },
  PAGE_LABEL: { key: 'PAGE_LABEL', value: 'Page' },
  OF_LABEL: { key: 'OF_LABEL', value: 'of' },
  UNTITLED_DOCUMENT: { key: 'UNTITLED_DOCUMENT', value: 'Untitled Document' },
  FIRST_CLASS: { key: 'FIRST_CLASS', value: 'First Class' },
  STANDARD_CLASS: { key: 'STANDARD_CLASS', value: 'Standard Class' },
  DISABLE_SHIFT_ALL: { key: 'DISABLE_SHIFT_ALL', value: 'Disable shift to all the documents' },
  APPLY_SHIFT_ALL: { key: 'APPLY_SHIFT_ALL', value: 'Apply shift to all the documents' },
  NONE_OPTION: { key: 'NONE_OPTION', value: 'None' },
  FONT_NOT_AVAILABLE: { key: 'FONT_NOT_AVAILABLE', value: '{{fontName}} font is not available.' },
  HOLD_STATUS: { key: 'HOLD_STATUS', value: 'Hold' },
  RELEASED_STATUS: { key: 'RELEASED_STATUS', value: 'Released' },
};
